export enum NotificationsType{
  INFO = 'info',
  WARN = 'warn',
  XMASS = 'xmass'
}
